import { lazyWithPreload } from 'react-lazy-with-preload';

const TicketListPage = lazyWithPreload(() => import('./pages/ticket-list/Page'));
const TicketDetailPage = lazyWithPreload(() => import('./pages/ticket-detail/Page'));

const Routes = [
    {
        path: 'support',
        element: <TicketListPage />,
    },
    {
        path: 'support/:ticketId',
        element: <TicketDetailPage />,
    },
];

export default Routes;
